import { ApiResponse, ApiResponseTypes, ISuccessResponse } from "../../shared/Types/responseTypes"
import { getHeadersFromOptions } from "../../shared/Helpers/http"

// TODO: This is temporary mock for get Deadline Message this will be replace with code below:
// export const getDeadlineMessage = (deliveryTime: string, merchantId: number | undefined, token: string): Promise<ApiResponse<any>> => {
//     return http(new Request(ApiHelper.path(`/merchants/${merchantId}/orders/deadlineMessage?deliveryTime=${deliveryTime}`), {
//         method: 'get',
//         headers: token ? getHeaders({ token }) : getHeaders()
//     }));
// };

interface IDeadlineMessageDto {
    deadlineMesssage: {
        isConfirmed: boolean
        message: {
            displayRule: string
            merchantMessage: string
        }
    }
}

export const getDeadlineMessage = async (
    deliveryTime: string, merchantId: number | undefined, token: string
): Promise<ApiResponse<IDeadlineMessageDto>> => {
    const response = await fetch(
        `https://516f60fe-6c1a-4eca-8b8b-5ffbf30a2932.mock.pstmn.io/merchants/${merchantId}/orders/deadlineMessage?deliveryTime=${deliveryTime}`,
        {
            method: 'GET',
            headers: getHeadersFromOptions({ token }),
        }
    );

    const text = await response.text();

    try {
        const data = JSON.parse(text);
        return {
            type: ApiResponseTypes.SUCCESS,
            data,
            method: 'GET',
            url: response.url,
            requestHeaders: [],
            responseCode: response.status,
            statusText: response.statusText,
            responseHeaders: []
        } as ISuccessResponse<IDeadlineMessageDto>;
    } catch {
        throw Error('Impossible to parse data')
    }
};
